import type { TemplateVariable } from '~/types/template'

const PLACEHOLDER = /\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g

export function extractVariableNames(body: string): string[] {
  const seen: string[] = []
  for (const m of (body ?? '').matchAll(PLACEHOLDER)) {
    if (!seen.includes(m[1])) seen.push(m[1])
  }
  return seen
}

export function syncVariables(body: string, existing: TemplateVariable[]): TemplateVariable[] {
  return extractVariableNames(body).map(name => ({
    name,
    sample: existing.find(v => v.name === name)?.sample ?? '',
  }))
}

export function toPositional(body: string, variables: TemplateVariable[]): string {
  return (body ?? '').replace(PLACEHOLDER, (_m, name: string) => {
    const index = variables.findIndex(v => v.name === name)
    if (index === -1) throw new Error(`unknown variable: ${name}`)
    return `{{${index + 1}}}`
  })
}

export function buildContentVariables(
  variables: TemplateVariable[],
  vars: Record<string, string>,
): Record<string, string> {
  return Object.fromEntries(variables.map((v, i) => [String(i + 1), vars[v.name] ?? '']))
}

export const KNOWN_MERGE_VARS = ['first_name', 'last_name', 'full_name', 'policy_holder'] as const

export function unknownVariables(names: string[]): string[] {
  const known = new Set<string>(KNOWN_MERGE_VARS)
  return names.filter(n => !known.has(n))
}
